import { render, staticRenderFns } from "./HaveMatches.vue?vue&type=template&id=7ed246ea&scoped=true"
import script from "./HaveMatches.vue?vue&type=script&lang=js"
export * from "./HaveMatches.vue?vue&type=script&lang=js"
import style0 from "./HaveMatches.vue?vue&type=style&index=0&id=7ed246ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed246ea",
  null
  
)

export default component.exports